import React, { useState } from 'react';
import { Box } from '@mui/material';
import CodeFormContainer from '../../containers/codemng/CodeFormContainer';
import CodeListContainer from '../../containers/codemng/CodeListContainer';

const CodeMngTemplate = ({ children }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setData(null);
  };

  const editFunction = (params) => {
    //console.log(params, 'parent');
    setData(params);
    setOpen(true);
  };

  // useEffect(() => {}, [data, open]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          m: 1,
        }}
      >
        <CodeListContainer editFunction={editFunction} handleAdd={handleOpen}/>
        <CodeFormContainer
          type={data != null ? 'edit' : 'add'}
          data={data}
          open={open}
          handleClose={handleClose}
        />
        
      </Box>
    </>
  );
};

export default CodeMngTemplate;
